import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import $ from 'jquery'
import swal from 'sweetalert';

class ListUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creatingCadmin: false,
            Lists: [],
            message: ""
        }
    }

    componentDidMount() {
        this.getTotalUser()
        $('[data-toggle="tooltip"]').tooltip();
    }
    getTotalUser = () => {
        var data = {
            s_id: ud.main_id,
            user_id: "",
            user_type: ud.usertype
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.usersList) {
                        _this.setState({ Lists: response.data.usersList, message: "No Record Found." });
                    }
                }else{
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalUser();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    SeeReports = (list) => {
        sessionStorage.setItem("User_reports_info", JSON.stringify(list))
        window.location.href = "/create/alignedworkflowsiteadmin"
    }


    render() {

        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h3>Users Report</h3>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb gradient-border">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item">Users Report</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xp-contentbar p-30">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card document_gradient_border padding-0 border-before-15 m-b-30">

                                <div class="card-header dv-center space-between">
                                    <h5 class="card-title text-black mb-0">Users Report</h5>
                                    {/* <button className="btn btn-primary btn-lg" title="Create new" onClick={this.createUser}><i className="mdi mdi-plus mr-2"></i>Create User</button> */}
                                </div>

                                <div class="card-body">
                                    <div class="table-responsive">
                                        {this.state.Lists.length === 0 ?
                                            this.state.message === "" ?

                                                // loader
                                                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                                // loader-end
                                                :
                                                <div className="message-no-record"> {this.state.message} </div>

                                            : null}
                                        <table class="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" style={{ width: "5%" }}>No</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th className="text-center">Phone</th>
                                                    <th className="text-center">User Type</th>
                                                    <th className="text-center">Report</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.Lists.map((list, index) =>
                                                    <tr>
                                                        <td className="text-center"><strong>{index + 1}.</strong></td>
                                                        <td>{list.name}</td>
                                                        <td>{list.email}</td>
                                                        <td className="text-center">{list.phone}</td>
                                                        <td className="text-center">{list.user_type == "SME" ? <span>{list.user_type}</span> : <span>{list.user_type}</span>}</td>

                                                        <td className="text-center">
                                                            <div class="tabledit-toolbar btn-toolbar" style={{ margin: "0 auto", display: "block" }}>
                                                                <div class="btn-group btn-group-sm">
                                                                    <button className="btn btn-info btn-xs" onClick={() => this.SeeReports(list)} data-toggle="tooltip" title="Preview">See Reports </button>

                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        )
    }
}
export default ListUsers

